import React from "react";
import { useMediaQuery } from "@mui/material";
import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";
import TabletLayout from "./TabletLayout";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const isCoarsePointer = useMediaQuery("(pointer: coarse)");
  const noHover = useMediaQuery("(hover: none)");
  const isMobileByWidth = useMediaQuery((theme: any) =>
    theme.breakpoints.down("sm")
  );
  const isTabletByWidth = useMediaQuery((theme: any) =>
    theme.breakpoints.between("sm", "md")
  );
  const useMobileLayout = isCoarsePointer || noHover || isMobileByWidth;

  return (
    <>
      {useMobileLayout && <MobileLayout>{children}</MobileLayout>}
      {!useMobileLayout && isTabletByWidth && (
        <TabletLayout>{children}</TabletLayout>
      )}
      {!useMobileLayout && !isTabletByWidth && (
        <DesktopLayout>{children}</DesktopLayout>
      )}
    </>
  );
};
